import { render, staticRenderFns } from "./FormChangeMetadataDatasourceGDS.vue?vue&type=template&id=a91a165c&scoped=true&lang=pug"
import script from "./FormChangeMetadataDatasourceGDS.vue?vue&type=script&lang=js"
export * from "./FormChangeMetadataDatasourceGDS.vue?vue&type=script&lang=js"
import style0 from "./FormChangeMetadataDatasourceGDS.vue?vue&type=style&index=0&id=a91a165c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91a165c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a91a165c')) {
      api.createRecord('a91a165c', component.options)
    } else {
      api.reload('a91a165c', component.options)
    }
    module.hot.accept("./FormChangeMetadataDatasourceGDS.vue?vue&type=template&id=a91a165c&scoped=true&lang=pug", function () {
      api.rerender('a91a165c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/FormChangeMetadataDatasourceGDS.vue"
export default component.exports